const { getCurrentMode } = require("@origino-io/fieldvalidations/src/helpers");
const { validateUniqueBulk } = require('@origino-io/fieldvalidations/src/services/front/validateUniqueField');
const { validateField } = require('@origino-io/fieldvalidations/src/validateField');
const { validateHideCondition } = require("../Helpers/validateHideCondition");

/**
 * calculate all de duplicate values in the data grid, creating a counter for each value on a field
 * @param {*} datagrid
 * @param {*} fieldsInfo
 * @returns
 */

function getUniquesInfo(datagrid, fieldsInfo, mode) {
  const uniqueFields = fieldsInfo.filter((row) => row.validations?.unique?.value);
  const nameFields = uniqueFields.map((field) => field.name);
  const uniquesInfo = [];
  const currentMode = getCurrentMode(mode);

  nameFields.forEach((name) => {
    const uniqueValues = datagrid.map((row) => row[name]);

    let info = datagrid.map((row) => ({
      pk: !row.id.toString().startsWith('fake-') ? row.id : null,
      uniqueVal: row[name],
    }));

    switch (currentMode) {
      case 'insert':
      case 'update':
        info = info.filter((item) => item != null).filter((item) => item.uniqueVal !== '');
        break;
      default:
        break;
    }

    const duplicates = uniqueValues.reduce((prev, cur) => {
      if (cur !== '') {
        // eslint-disable-next-line no-param-reassign
        prev[cur] = (prev[cur] || 0) + 1;
      }
      return prev;
    }, {});

    uniquesInfo.push({ fieldName: name, duplicates, tuples: info });
  });

  return uniquesInfo;
}

async function checkAllUniques(
  uniques,
  fields,
  { objectType, pkObjectType, globalModel, token, mode, previusUniques, holder }
) {
  const responseUniques = [];

  const uniqueFields = fields.filter((row) => row.validations?.unique?.value);

  for (const field of uniqueFields) {
    try {
      const prevUn = previusUniques.find((prev) => prev.fieldName === field.name);
      const finalList = {
        fieldName: field.name,
        duplicates: prevUn?.duplicates || [],
        tuples: prevUn?.tuples || [],
      };
      const uniqueVals = uniques.find((unique) => unique.fieldName === field.name);
      const currentVals = uniqueVals.tuples?.filter(
        (tuple) =>
          !prevUn?.tuples?.some(
            (prev) => tuple.pk === prev.pk && tuple.uniqueVal === prev.uniqueVal
          )
      );
      if (currentVals.length > 0) {
        const response = await validateUniqueBulk(
          field.name,
          {
            objectType,
            pkObjectType,
            uniqueValues: currentVals,
            globalModel,
            mode,
            holder,
          },
          token
        );
        const currentTuples = await response.data;

        currentTuples.tuples.forEach((tuple) => {
          if (previusUniques.tuples?.length > 0) {
            const newTuple = previusUniques.tuples.find(
              ({ pk, uniqueVal }) => pk === tuple.pk && uniqueVal === tuple.uniqueVal
            );
            if (newTuple == null) {
              finalList.tuples.push(newTuple);
            }
          } else {
            finalList.tuples.push(tuple);
          }
        });
      }
      responseUniques.push(finalList);
    } catch (error) {
      console.log('error on ForEach checkAllUniques: ', error);
    }
  }

  return responseUniques;
}

/**
 * validate a matrix (datagrid) with the validations of each fields,
 * returning all the errors of each particular cell
 * #TODO: not implemented yet
 * @param {*} datagrid
 * @param {*} fieldsInfo
 * @param {*} options
 * @returns
 */
export async function validateGrid(datagrid, fieldsInfo, options = {}) {
  let errorCount = 0;
  const listErrorsId = [];
  const resultErrors = [];
  const uniquesInfo = getUniquesInfo(datagrid, fieldsInfo, options.mode);
  const resultUniques = await checkAllUniques(uniquesInfo, fieldsInfo, options);

  for (const [index, dList] of datagrid.entries()) {
    for (const field of fieldsInfo) {
      const isEditable = options.editableFields[field.name];

      if (isEditable && !validateHideCondition(field, datagrid[index])) {
        const currentVal = dList[field.name];
        const finalOptions = { ...options };
        finalOptions.fieldType = field.type;
        finalOptions.fieldName = field.name;
        finalOptions.selectValues = field.values;
        finalOptions.pk = dList.id;
        finalOptions.gridBulk = true;

        try {
          const errors = await validateField(currentVal, field.validations, finalOptions);
          if (field.validations?.unique?.value) {
            const currentsDup = uniquesInfo.find((item) => item.fieldName === field.name);

            if (currentsDup && currentVal) {
              const counter = currentsDup.duplicates[currentVal];
              if (counter > 1) {
                errors.push('Duplicate value in the current column');
              }
            }
            const restUnique = resultUniques.find((item) => item.fieldName === field.name);

            const currentUnique = restUnique?.tuples?.find(
              (tuple) => tuple.uniqueVal === currentVal && dList.id
            );
            if (currentUnique != null) {
              if (currentUnique?.canUse === false) errors.push(field.validations.unique.message);
            }
          }

          if (errors.length !== 0) {
            resultErrors.push({ row: index, column: field.name, errors });
            errorCount += 1;
            if (listErrorsId.indexOf(dList.id) === -1) listErrorsId.push(dList.id);
          }
        } catch (error) {
          console.log('error on validateField on bulk', error);
        }
      }
    }
  }

  return { errorCount, listErrorsId, resultErrors, resultUniques };
}

// module.exports = { validateGrid };